import { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { BookText, Building2 } from "lucide-react";
import { api } from "@/lib/appApi";
import NewsCard from "@/components/public/NewsCard";

export default function BidangPage() {
  const { slug } = useParams();
  const { unitMap = {} } = useOutletContext() || {};
  const [unit, setUnit] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setUnit(null); setNotFound(false);
    api.get(`/public/units/${slug}`).then((r) => setUnit(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-gray-500">Unit tidak ditemukan.</div>;
  if (!unit) return <div className="max-w-7xl mx-auto px-4 py-20 text-center text-gray-500">Memuat…</div>;

  return (
    <div>
      <div className="bg-dlh-green text-white">
        <div className="max-w-7xl mx-auto px-4 py-10">
          <p className="text-dlh-greenLight font-bold uppercase tracking-widest text-xs mb-2">Sekretariat dan Bidang DLH</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-extrabold leading-tight break-words">{unit.full_name || unit.name}</h1>
          {unit.is_support && <p className="mt-2 text-white/70 text-sm">Sekretariat merupakan unit pendukung, bukan bidang teknis.</p>}
          {unit.pasal && <span className="inline-block mt-3 bg-white/15 px-3 py-1 rounded text-sm">Dasar rujukan: {unit.pasal}</span>}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1 space-y-6">
          <div className="bg-dlh-greenPale rounded-lg p-5">
            <h2 className="font-serif font-bold text-dlh-green flex items-center gap-2 mb-2"><BookText className="h-5 w-5" /> Ringkasan Tugas & Fungsi</h2>
            <p className="text-sm text-gray-700 leading-relaxed">{unit.ringkasan}</p>
            <p className="text-[11px] text-gray-500 mt-3 italic">Ringkasan informatif, bukan pengganti naskah peraturan resmi.</p>
          </div>
          {unit.subunits?.length > 0 && (
            <div className="bg-white rounded-lg border border-gray-200 p-5">
              <h2 className="font-serif font-bold text-dlh-green flex items-center gap-2 mb-3"><Building2 className="h-5 w-5" /> {unit.is_support ? "Sub Bagian" : "Seksi"}</h2>
              <ul className="space-y-2">
                {unit.subunits.map((s, i) => <li key={i} className="text-sm text-gray-700 leading-snug pl-3 border-l-2 border-dlh-greenLight">{s.name}</li>)}
              </ul>
            </div>
          )}
          {unit.head_official && (
            <div className="bg-white rounded-lg border border-gray-200 p-5">
              <h2 className="font-serif font-bold text-dlh-green mb-1">Pejabat</h2>
              <p className="text-sm text-gray-700">{unit.head_official}</p>
            </div>
          )}
        </div>

        <div className="lg:col-span-2">
          <h2 className="font-serif text-2xl font-extrabold text-dlh-green mb-6 pl-4 border-l-4 border-dlh-orange">Berita Terbaru</h2>
          {unit.articles?.length === 0 ? (
            <div className="rounded-xl border border-dashed border-gray-300 p-12 text-center text-gray-500">Belum tersedia berita terbit untuk unit ini.</div>
          ) : (
            <div className="grid sm:grid-cols-2 gap-6" data-testid="bidang-articles">
              {unit.articles.map((a) => <NewsCard key={a.id} article={a} unitMap={unitMap} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
